"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_TEAMS_CANCEL = exports.FETCH_TEAMS_FAILED = exports.FETCH_TEAMS_SUCCESS = exports.FETCH_TEAMS_REQUEST = void 0;
exports.FETCH_TEAMS_REQUEST = '@teams/FETCH_TEAMS_REQUEST';
exports.FETCH_TEAMS_SUCCESS = '@teams/FETCH_TEAMS_SUCCESS';
exports.FETCH_TEAMS_FAILED = '@teams/FETCH_TEAMS_FAILED';
exports.FETCH_TEAMS_CANCEL = '@teams/FETCH_TEAMS_CANCEL';